export default class Widgets {
  constructor() {
    this.toggleable = $('.footer .widget');
  }

  init() {
    this.toggleWidgetContent();
  }

  toggleWidgetContent() {
    const toggle = $('h3', this.toggleable);

    toggle.on('click', (e) => {
      const toggleTarget = $(e.currentTarget);
      const content = $('+ div', toggleTarget);
      const parent = toggleTarget.parent();

      content
        .parent()
        .toggleClass('toggled', !parent.hasClass('toggled'));
    });
  }
}

$(() => {
  new Widgets().init();
});
